import type { Catalog } from "../types";

let cached: Promise<Catalog> | null = null;

export function loadCatalog(): Promise<Catalog> {
  if (!cached) {
    cached = fetch("/data/catalog.json", { cache: "no-cache" }).then(async (response) => {
      if (!response.ok) throw new Error("The catalog could not be loaded.");
      return (await response.json()) as Catalog;
    });
  }
  return cached;
}

export const money = (value: number | null) =>
  value === null
    ? "Request a quote"
    : new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(value);
